<div
  style="position: absolute; left: calc((100vw / 2) - 50px); top: calc((100vh / 2) - 50px); z-index: 1000; width: 100px; height: 100px">
  <ngx-spinner [bdColor]="bdColor"
    size="medium"
    color="#4D33CC"
    [type]="type"
    [fullScreen]="true"
    [zIndex]="998">
    @if (message) {
      <div
      class="message-box">{{ message }}</div>
    }
  </ngx-spinner>
</div>